/*
 * File: /src/store/modules/menuService.js
 * Created Date: Sunday May 12th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 12th May 2019 10:42:50 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import queueService from '../../services/queueService';

const state = {
  queues: undefined
};

const getters = {
  getQueues: state => {
    return state.queues;
  },
  // Default call type for calls answered from the queue, if any
  getQueueCallTypeId: state => (queueId) => {
    return state.queues?.find((q) => q.id == queueId)?.call_type_id ?? null;
  },
};
const actions = {
  fetchQueues({ commit }, params = { sort: 'name:asc' }) {
    return queueService.fetchQueues(params).then((r) => {
      commit('setQueues', r.data);
    });
  },
  unloadQueues({ commit }) {
    commit('setQueues', undefined);
  },
};
const mutations = {
  setQueues(state, d) {
    state.queues = d;
    // state.queues = Object.assign([], d);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
